import { ROLE_TYPE } from "@supplier/meta";
import salesManageRouter from "./salesManage";
import purchasingManageRouter from "@/routers/purchaseSalesInventory/purchaseManagement";
import contractRouter from "@/routers/purchaseSalesInventory/contractManagement";
import fundRouter from "@/routers/purchaseSalesInventory/fundMangement";
import financingRouter from "@/routers/purchaseSalesInventory/financing";
import invoiceRouter from "@/routers/purchaseSalesInventory/invoice";
import storageRouter from "@/routers/purchaseSalesInventory/storage";
import logisticsRouter from "@/routers/purchaseSalesInventory/logistics";
import statementStatisticsRouter from "@/routers/purchaseSalesInventory/statementStatistics";
import accountsPayableRouter from "@/routers/purchaseSalesInventory/accountsPayable";
import { UserStore } from "@/stores/user";
import { hasPurchaseSalesInventory } from "@/utils/permission";
import { AccountStore, AccountType } from "@/stores/account";

const hasPurchaseSalesInventoryRouteAuth = ({
    userStore,
    accountStore
}: {
    userStore: UserStore;
    accountStore: AccountStore;
}) => {
    let roles = userStore.userInfo.proxyAccount?.roles;
    // 关联企业跟随主账号角色权限，避免只看代理账号导致菜单和路由判断不一致。
    if (accountStore.accountType === AccountType.ASSOCIATED) {
        roles = userStore.userInfo.customer?.roles;
    }
    // 顶层路由注册用正向权限判断；菜单隐藏规则在 hidden 中取反复用。
    return (
        !!roles?.includes(ROLE_TYPE.PURCHASE_CUSTOMER.code) &&
        (!accountStore.isSubAccount || hasPurchaseSalesInventory(userStore.userInfo.permissions))
    );
};

export const purchaseSalesInventoryRouters = [
    {
        path: "/purchaseSalesInventory",
        name: "PurchaseSalesInventory",
        meta: {
            title: "进销存管理",
            icon: "icon-jinxiaocun",
            auth: hasPurchaseSalesInventoryRouteAuth,
            hidden: ({ userStore, accountStore }: { userStore: UserStore; accountStore: AccountStore }) => {
                // 进销存管理和仓储业务根据企业身份展示，拥有采购客户身份才展示进销存管理，拥有仓储客户身份才展示仓储业务。
                return !hasPurchaseSalesInventoryRouteAuth({ userStore, accountStore });
            }
        },
        children: [
            ...purchasingManageRouter,
            ...salesManageRouter,
            ...contractRouter,
            ...fundRouter,
            ...financingRouter,
            ...accountsPayableRouter,
            ...invoiceRouter,
            ...logisticsRouter,
            ...storageRouter,
            ...statementStatisticsRouter
        ]
    }
];
